
export const ConveyanceType = {
    Ferries: 'ferries',
    Van: 'van',
    Bus: 'bus',
    Camry: 'camry',
    Hundai: 'hundai',
}